import ls from '@/utils/local-storage'; // 存user info
import router from '@/router';

const user = {
  namespaced: true,
  state: {
    user: ls.getItem('user')
  },
  mutations: {
    storeUser (state, user) {
      state.user = user;
      ls.setItem('user', user);
    }
  },
  actions: {
    login ({ commit }, user) {
      if (user) commit('storeUser', user);
      router.push('/connect');
    }
  },
  getters: {
    getUser: state => state.user
  }
};

export default user;
